/** keep-alive 프로그램 페이지는 `<Route>` 밖에서 렌더되므로 `useParams` 대신 pathname 파싱 */

export function projectIdFromProgramPath(pathname: string): string {
  const m = pathname.match(/^\/program\/project\/([^/]+)/);
  return m ? decodeURIComponent(m[1]) : '';
}

export function trackNameFromProgramPath(pathname: string): string {
  const m = pathname.match(/^\/program\/track\/(.+)$/);
  return m ? decodeURIComponent(m[1]) : '';
}
